export const CALC_EXPORT_COPY = {
  allowDraftLoads: "Allow clearly labeled draft load sheets",
  reviewAction: "Review export",
  generateAction: "Generate PDF",
  ready: "Ready",
  needsAttention: "Needs attention",
  reportReady: "Report ready",
  exportFailed: "Export failed",
  generatingReport: "Generating report",
  reportFailedFallback: "The report could not be generated.",
  runInBackground: "Run in background",
  downloadPdf: "Download PDF",
  tryAgain: "Try again",
  browserDownloadNotReady: "This export is not ready to download.",
  forEngineeringReview: "For engineering review",
  reviewedCalculation: "Reviewed calculation",
  coverDisclaimer: "This report presents calculated results and source information for engineering review. It is not a professional seal.",
} as const;

export function loadStatusExportMessage(
  template: string,
  status: "partial" | "blocked" | "not applicable",
): string {
  return template.replace("{status}", status);
}
